<div class="landing-title" [class.justify-content-between]="spaceBetweenTitleAndTrailing">
  <p class="large">
    {{ title }}
  </p>
  <ng-content></ng-content>
</div>
